let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eUBCy")).then(() => parcelRequire('bIv5I'));